<template>

  <div class="common-notification">
    <transition-group name="notification" tag="div" >
      <div
        class="notification-item-box"
        :style="{ top: `${86 * index}px`}"
        v-for="(item, index) in messageList"
        :key="item.id"
      >
        <div v-if="item.type === 'coupon'" class="notification-item">
          <div class="item-left">
            <div class="notification-content-top">
              <img
                class="notification-icon"
                src="../assets/imgs/icon_notify.png"
                alt=""
              />
              <div class="title">{{ getCouponDispayMessage(item.data) }}</div>
            </div>
            <div class="vote-title" v-if="item.data && item.data.end_date">
              <!-- 大于7天展示时间段 7天内展示多少天过期 小于1天倒计时 -->
              <div v-if="getCouponDays(item.data) >= 7">
                有效期{{ item.data.start_date }}至{{ item.data.end_date }}
              </div>
              <div v-else-if="getCouponDays(item.data) < 7 && getCouponDays(item.data) >= 1">
                {{ Math.ceil(getCouponDays(item.data)) }}天后过期
              </div>
              <count-down v-else :endTime="item.data.end_date"></count-down>
            </div>
          </div>
          <div class="item-right">
            <div class="view-btn" @click="gotoMyCoupon">现在查看</div>
          </div>
        </div>
        <div v-if="item.type === 'three-order-activity'" class="notification-item">
          <div class="item-left">
            <div class="notification-content-top">
              <img
                class="notification-icon"
                src="../assets/imgs/activity/three-order-activity/icon_notify.png"
                alt=""
              />
              <div class="title">{{ item.data.title }}</div>
            </div>
            <div class="vote-title">
              {{ item.data.msg }}
            </div>
          </div>
          <div class="item-right">
            <div class="view-btn" @click="gotoThreeOrderActivity">现在查看</div>
          </div>
          
        </div>
      </div>
    </transition-group>
    
  </div>
</template>

<script>
import CountDown from './count-down.vue';
import utils from '../../src/libs/utils';
import User from '../libs/user';
import http from '../libs/http';

let msgId = 0;

export default {
  components: {
    CountDown,
  },
  computed: {},
  data() {
    return {
      messageList: [],
      waitMessageList: [],
      addMessageTimeout: null,
    };
  },
  created() {
    if (User.isLogin()) {
      this.startLoopNotify();
    }
  },
  watch: {
  },
  methods: {
    startLoopNotify() {
      this.triggerNotify();
      this.pollingInterval = setInterval(() => {
        // 每次执行进行判断是否退出了，退出了则不需要触发了,非注销（主要给注销账号以及移交管理员弹窗使用）
        if (User.isLogin() && !User.isSignOut) {
          this.triggerNotify();
        } else {
          clearInterval(this.pollingInterval);
        }
      }, 10000);
    },
    // 获取通知
    async triggerNotify() {
      try {
        const data = await http.post('/peer_coupon_unread_query', {}, { noToast: true });

        if (data.peer_coupon && data.peer_coupon.length) {
  
          this.waitMessageList = data.peer_coupon.map(item => ({
            id: ++msgId,
            type: 'coupon',
            data: item,
          }));

        } else {
          const expirationRes = await http.post('/peer_activity_expiration_query', {}, { noToast: true });

          if (!expirationRes.message_list || !expirationRes.message_list[0]) return;
          this.waitMessageList = [
            {
              id: ++msgId,
              type: 'three-order-activity',
              data: expirationRes.message_list[0],
            },
          ];
        }
        this.addMessageList();
      } catch (error) {
        //
      }
    },
    addMessageList() {
      if (!this.waitMessageList.length) return;
      this.messageList.push({
        ...this.waitMessageList.shift(),
        // 添加后，6秒后删除
        timer: setTimeout(() => {
          console.log(1111111);
          this.removeMessageListFirst();
        }, 6000),
      });
      
      // 每次添加一个，然后过一会再加一个，为了动画
      this.addMessageTimeout = setTimeout(() => {
        this.addMessageList();
      }, 300);
    },
    // 删除第一个message
    removeMessageListFirst() {
      if (!this.messageList.length) return;
      const item = this.messageList.shift();
      // 为了防止其他的情况的删除，导致message重复删除，清空一下自身的timer
      clearTimeout(item.timer);
    },
    // 循环清空所有message
    removeAllMessageList() {
      if (!this.messageList.length) return;
      this.removeMessageListFirst();
      setTimeout(() => {
        this.removeAllMessageList();
      }, 300);
    },
    getCouponDispayMessage(coupon) {
      const text = coupon.reach_reduce ? (`满${coupon.reach_reduce / 100}元`) : '无门槛';
      if (coupon.peer_coupon_type_id === 0) {
        return `您收到一张${text}减${coupon.cash_reduce / 100}优惠券`;
      } else if (coupon.peer_coupon_type_id === 1) {
        return `您收到一张${text}打${utils.formatNumberWithDecimals(coupon.cash_reduce / 1000)}折的优惠券`;
      }
      return `您收到一张满${coupon.reach_reduce_num}本减${coupon.reduce_num}本的优惠券`;
    },
    getCouponDays(coupon) {
      return utils.getDaysDifference(new Date(), coupon.end_date);
    },
    gotoMyCoupon() {
      this.removeAllMessageList();
      this.$router.push('/user/coupon');
    },
    gotoThreeOrderActivity() {
      this.removeAllMessageList();
      this.$router.push('/user/equity');
    },
  },
};
</script>

<style scoped lang="less">
.common-notification{
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 1120px;
  .notification-item-box{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.3s;
    .notification-item{
      width: 100%;
      background: #fff;
      height: 76px;
      background: #fff;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      border-radius: 2px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item-left{
        flex-grow: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .notification-content-top {
          display: flex;
          justify-content: flex-start;
          min-height: 22px;
          align-items: center;
          gap: 7px;
          .notification-icon {
            width: 30px;
            height: 32px;
          }
          .title {
            font-weight: bold;
            font-size: 16px;
            color: #2f333d;
            line-height: 22px;
            text-align: left;
          }
        }

        .vote-title {
          font-weight: 400;
          font-size: 14px;
          color: #5f666e;
          line-height: 14px;
          text-align: left;
          margin-left: 37px;
        }
      }
      .item-right{
        .view-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 92px;
          height: 32px;
          line-height: 32px;
          border-radius: 2px;
          border: 1px solid #599fff;
          font-size: 16px;
          color: #599fff;
          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
      }
    }
    
  }
}

.notification-enter-active, .notification-leave-active {
  transition: all 3s;
}
.notification-enter, .notification-leave-to{
  opacity: 0;
  transform: translateY(-20px);
}
</style>



// WEBPACK FOOTER //
// src/components/common-notification.vue